<div class="title">{{ 'finance.payout' | translate }}</div>

<form class="row" [formGroup]="form">
  <rp-input formControlName="amountCents" type="text" [placeholder]="'finance.amount' | translate" mask="separator.0" />

  <rp-select
    formControlName="walletId"
    [items]="activePaymentMethods()"
    [placeholder]="'finance.method' | translate"
    (selectScroll)="onScroll()"
    displayField="walletName"
    selectedField="walletId"
  />
</form>

@if (payoutStatusEnabled()) {
  <rp-button class="margin-top" (click)="makePayout()" [disabled]="!form.valid || !payoutStatusEnabled()" fullWidth>
    {{ (payoutStatusEnabled() ? 'finance.makeRequest' : 'finance.withdrawalForbidden') | translate }}
  </rp-button>
} @else {
  <div class="withdrawal-forbidden-msg-container">
    <rp-icon [iconName]="iconName.Danger" [color]="iconColorEnum.RED" size="s" />
    <span>{{ 'finance.withdrawalForbidden' | translate }}</span>
  </div>
}
